export default __webpack_public_path__ + "static/neural-logo-f3f95e30963a92d4d0d1eae781f44f3a.png";